interface TableMobileTextProps {
  text: string;
}

function TableMobileText({text}: TableMobileTextProps) {
  return (
    <span className="c-table-mobile-text">
      {text}
    </span>
  );
}

export default TableMobileText;
